import React from "react";
import { Button } from "@mui/material";
import { VARIATIONS_BTN } from "./constants";
import "./style.scss";
import cn from "classnames";
import { DEFAULT_FORM_ID } from "constants";

export const ButtonV2 = ({
  formId = DEFAULT_FORM_ID,
  variant = VARIATIONS_BTN.TEXT,
  children,
  color,
  className,
  onClick,
  uppercase,
  capitalize,
  startIcon,
  endIcon,
  disabled,
  type,
  isLoading,
}) => {
  return (
    <Button
      type={type}
      loading={isLoading}
      {...(type === "submit" && { form: formId })}
      startIcon={startIcon}
      onClick={onClick}
      className={cn("btn-component", className, {
        "btn-component_uppercase": uppercase,
        "btn-component_capitalize": capitalize,
      })}
      color={color}
      variant={variant}
      endIcon={endIcon}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};
